import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { BUTTON_SIZES, BUTTON_VARIANTS, IconButton } from 'ui/button';
import { AiSummarizeColor16 } from 'ui/icons';
import { PopoverTrigger } from 'ui/popover';
import { testIds } from './AIQuerySummary';

export const AIQuerySummaryTriggerBtn = () => {
  const { t } = useTranslation();

  return (
    <PopoverTrigger data-test={testIds.trigger} asChild>
      <IconButton
        aria-label={t('storybook.ai.summary.generateSummary')}
        type="button"
        variant={BUTTON_VARIANTS.SECONDARY}
        title={t('storybook.ai.summary.generateSummary')}
        size={BUTTON_SIZES.SMALL}
      >
        <AiSummarizeColor16 />
      </IconButton>
    </PopoverTrigger>
  );
};
